import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "trip-assigment-popup-wrapper" }
const _hoisted_2 = { class: "trip-assigment-popup" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 11 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.787794 0.000340998C0.631812 0.000381975 0.479387 0.0469545 0.350004 0.134104C0.220621 0.221254 0.120161 0.345022 0.0614663 0.489583C0.00277158 0.634145 -0.0114904 0.792932 0.0205036 0.945644C0.0524977 1.09836 0.129294 1.23805 0.241074 1.34688L4.39124 5.49832L0.241074 9.64975C0.165823 9.72203 0.105743 9.80859 0.0643549 9.90438C0.0229668 10.0002 0.00110191 10.1033 4.05857e-05 10.2076C-0.00102073 10.312 0.018743 10.4155 0.0581743 10.5121C0.0976055 10.6087 0.155912 10.6965 0.229678 10.7702C0.303444 10.844 0.391188 10.9024 0.48777 10.9418C0.584352 10.9812 0.687831 11.001 0.792147 11C0.896463 10.9989 0.999519 10.977 1.09528 10.9356C1.19104 10.8942 1.27758 10.8341 1.34983 10.7588L5.5 6.60741L9.65017 10.7588C9.72242 10.8341 9.80896 10.8942 9.90472 10.9356C10.0005 10.977 10.1035 10.9989 10.2078 11C10.3122 11.001 10.4156 10.9812 10.5122 10.9418C10.6088 10.9024 10.6966 10.844 10.7703 10.7703C10.8441 10.6965 10.9024 10.6087 10.9418 10.5121C10.9813 10.4155 11.001 10.312 11 10.2076C10.9989 10.1033 10.977 10.0002 10.9356 9.90438C10.8943 9.80859 10.8342 9.72203 10.7589 9.64975L6.60875 5.49832L10.7589 1.34688C10.8722 1.23671 10.9496 1.09487 10.9809 0.939949C11.0123 0.785028 10.9961 0.624253 10.9345 0.478692C10.8729 0.333131 10.7688 0.209576 10.6358 0.124218C10.5028 0.0388602 10.3472 -0.00431821 10.1892 0.000340998C9.98552 0.00641261 9.79218 0.0915746 9.65017 0.237785L5.5 4.38922L1.34983 0.237785C1.27676 0.16265 1.18938 0.102928 1.09284 0.0621449C0.99631 0.0213623 0.892584 0.000347109 0.787794 0.000340998Z",
    fill: "black"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "trip-header-wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "trip-assignment-header"
}
const _hoisted_7 = {
  key: 1,
  class: "trip-assignment-header"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "trip-assignment-subheader" }, "See where you left off and what the next steps are", -1)
const _hoisted_9 = {
  key: 0,
  class: "trip-season-selector"
}
const _hoisted_10 = { class: "trip-table-wrapper" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "table-header" }, "Builder Statuses", -1)
const _hoisted_12 = {
  key: 0,
  class: "builder-statuses"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("tr", { class: "builder-statuses-header" }, [
  /*#__PURE__*/_createElementVNode("th", { align: "left" }, "Builder"),
  /*#__PURE__*/_createElementVNode("th", { align: "left" }, "Status / Trip Assigned"),
  /*#__PURE__*/_createElementVNode("th", { align: "left" }, "Shortcut")
], -1)
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "bolded clickable" }
const _hoisted_16 = { class: "bolded-link clickable" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "link clickable" }
const _hoisted_19 = { class: "bolded-link clickable" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "link clickable bolded" }
const _hoisted_22 = {
  key: 4,
  class: "faded"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "close-button",
        onClick: $setup.tryClosePopup
      }, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        (!$props.message)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Welcome Back!"))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($props.message), 1)),
        _hoisted_8
      ]),
      ($setup.builderSeasons.accountSpansSeasons)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode($setup["SeasonSelector"], {
              modelValue: $setup.selectedSeason,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedSeason) = $event))
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        ($setup.buildersStatuses)
          ? (_openBlock(), _createElementBlock("table", _hoisted_12, [
              _hoisted_13,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.buildersStatuses, (status) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: status.name
                }, [
                  _createElementVNode("td", null, _toDisplayString(status.name), 1),
                  (status.builderStatus.trip !== null)
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 0,
                        class: _normalizeClass({important: status.important}),
                        onClick: ($event: any) => ($setup.routeToTrip(status.builderStatus.link))
                      }, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(status.builderStatus.status), 1),
                        _createTextVNode(),
                        _createElementVNode("span", _hoisted_16, _toDisplayString(status.builderStatus.trip), 1)
                      ], 10, _hoisted_14))
                    : (_openBlock(), _createElementBlock("td", {
                        key: 1,
                        class: _normalizeClass({important: status.important})
                      }, _toDisplayString(status.builderStatus.status), 3)),
                  (status.shortcutLocation)
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 2,
                        onClick: ($event: any) => ($setup.routeShortcut(status.shortcutLink, status.builderId))
                      }, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(status.shortcut), 1),
                        _createTextVNode(),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(status.shortcutLocation) + " >", 1)
                      ], 8, _hoisted_17))
                    : (status.shortcutAction)
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 3,
                          onClick: status.shortcutAction
                        }, [
                          _createElementVNode("span", _hoisted_21, _toDisplayString(status.shortcut), 1)
                        ], 8, _hoisted_20))
                      : (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString(status.shortcut), 1))
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", { class: "btn-wrapper" }, [
        _createElementVNode("button", {
          class: "okay",
          onClick: $setup.tryClosePopup
        }, "Okay")
      ])
    ])
  ]))
}